import chunk from 'lodash/chunk';

import { axios } from '@lib/axios';
import type { AuditLogEventCreateParams } from 'chaika-frontend-types/frontend-cms';

const BASE_URL = '/api/audit-log';

export class AuditLogApi {
    public static async addEvent(event: AuditLogEventCreateParams): Promise<void> {
        await axios.post(`${BASE_URL}/event`, { event });
    }

    public static async addEvents(events: AuditLogEventCreateParams[]): Promise<void> {
        const chunked = chunk(events, 100);
        for (const events of chunked) {
            await axios.post(`${BASE_URL}/events`, { events });
        }
    }
}
